module.exports = __webpack_public_path__ + "static/hexaware-dd648f74e05c2675c368837d19dda970.png";